import { render, staticRenderFns } from "./ItemDoses.vue?vue&type=template&id=6eb060b6&scoped=true"
import script from "./ItemDoses.vue?vue&type=script&lang=js"
export * from "./ItemDoses.vue?vue&type=script&lang=js"
import style0 from "./ItemDoses.vue?vue&type=style&index=0&id=6eb060b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb060b6",
  null
  
)

export default component.exports